import { render, staticRenderFns } from "./SKO2025.vue?vue&type=template&id=3592bab4&scoped=true&"
import script from "./SKO2025.vue?vue&type=script&lang=js&"
export * from "./SKO2025.vue?vue&type=script&lang=js&"
import style0 from "./SKO2025.vue?vue&type=style&index=0&id=3592bab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3592bab4",
  null
  
)

export default component.exports